module.exports = __webpack_public_path__ + "img/youtube.3e73e985.svg";